module.exports = __webpack_public_path__ + "assets/good.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/good.png
// module id = 1226
// module chunks = 7